/**
 * Check if a value is defined.
 * @param value
 */
export const isNil = <T>(value: T | null | undefined): value is undefined => {
    return value === null || value === undefined;
};

export function isString (value: string | unknown): value is string {
    return typeof value === 'string';
}